import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { isMusicOn, onMusicChange, setMusicOn } from "../utils/sound";

// Live equalizer-graph icon for the music toggle.
const EqIcon = ({ live }) => (
  <span className="flex h-[18px] items-end gap-[2.5px]" aria-hidden="true">
    {[0, 1, 2, 3].map((i) => (
      <span key={i} className={`eq-bar${live ? " eq-bar-live" : ""}`} style={{ animationDelay: `${i * 0.14}s` }} />
    ))}
  </span>
);

// Floating music pill — bottom-left, opposite the call FAB. Toggles the
// background song (HOME – Resonance). On by default; loops forever.
export const FloatingSound = () => {
  const [on, setOn] = useState(isMusicOn());
  useEffect(() => onMusicChange(setOn), []);

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.5, y: 16 }}
      animate={{ opacity: 1, scale: 1, y: 0 }}
      transition={{ delay: 1.4, type: "spring", stiffness: 260, damping: 18 }}
      className="fixed bottom-5 left-5 z-40"
    >
      <button
        type="button"
        data-testid="music-toggle"
        aria-pressed={on}
        aria-label={on ? "Mute background music" : "Play background music"}
        title={on ? "Music on" : "Music off"}
        onClick={() => setMusicOn(!on)}
        className={`glass-liquid relative inline-flex h-10 w-10 items-center justify-center rounded-full border shadow-[0_10px_32px_-8px_rgba(0,0,0,0.65)] transition-colors duration-300 ${
          on ? "border-volt/60 text-volt" : "border-ink/15 text-ink/50 hover:border-ink/45 hover:text-ink"
        }`}
      >
        <EqIcon live={on} />
        {on && (
          <motion.span
            aria-hidden="true"
            className="absolute inset-0 rounded-full border border-volt/50"
            animate={{ scale: [1, 1.35], opacity: [0.7, 0] }}
            transition={{ duration: 1.6, repeat: Infinity, ease: "easeOut" }}
          />
        )}
      </button>
    </motion.div>
  );
};
